import api from './http';

// Backup
export const exportBackupJson = () => api.get('/backup/export/json', { responseType: 'blob' });
export const exportBackupExcel = () => api.get('/backup/export/excel', { responseType: 'blob' });
export const exportCollectionJson = (collection) => api.get(`/backup/export/json/${collection}`, { responseType: 'blob' });
export const exportCollectionExcel = (collection) => api.get(`/backup/export/excel/${collection}`, { responseType: 'blob' });
export const getCollectionsList = () => api.get('/backup/collections');
export const importCollectionFile = (collection, file, mode) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('mode', mode);
  return api.post(`/backup/import/${collection}`, fd);
};
export const importBackupJson = (file, mode) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('mode', mode);
  return api.post('/backup/import/json', fd);
};
export const importBackupExcel = (file, mode) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('mode', mode);
  return api.post('/backup/import/excel', fd);
};
export const previewImport = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/backup/preview', fd);
};
export const getBackupHistory = () => api.get('/backup/history');
export const previewExcelImport = (file, collection) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('collection', collection);
  return api.post('/backup/preview-excel', fd);
};
export const validateImport = (file, collection, mapping, detectDuplicates = true) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('collection', collection);
  fd.append('mapping', JSON.stringify(mapping));
  fd.append('detect_duplicates', detectDuplicates ? 'true' : 'false');
  return api.post('/backup/validate', fd);
};
export const importWithMapping = (file, collection, mapping, mode = 'merge', skipDuplicates = true) => {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('collection', collection);
  fd.append('mapping', JSON.stringify(mapping));
  fd.append('mode', mode);
  fd.append('skip_duplicates', skipDuplicates ? 'true' : 'false');
  return api.post('/backup/import-mapped', fd);
};
